module.exports = __webpack_public_path__ + "static/media/use_case.af7baa4b.svg";